<template>
    <div class="topicDetails">
        <div class="tophead" v-if="!isWx" :style="{'background-color': headFlag ? '#fff' : 'transparent'}">
            <i @click="goBack" :class="[headFlag ? 'back_2' : 'back_1']"></i>
            <span>{{ tabMenuFlag ? topicDetails.title : "" }}</span>
        </div>
        <div class="content">
            <div class="bg">
                <van-image
                    lazy-load
                    fit="cover"
                    width="100%"
                    height="300"
                    :src="topicDetails ? topicDetails.img : ''"
                />
            </div>
            <div class="listBox">
                <div class="list">
                    <div class="intro" ref="intro">
                        <p class="title">{{topicDetails ? topicDetails.title : ''}}</p>
                        <p :class="{'van-multi-ellipsis--l2': !isShow}">{{topicDetails ? topicDetails.desc : ''}}</p>
                        <div class="open flex align-center" @click="showToggle">
                            <span>{{ isShow ? "收起" : "展开" }}</span>
                            <i ref="showIcon"></i>
                        </div>
                    </div>
                </div>
                <ul :style="{'top': isWx ? 0 : '60px'}" :class="{'tab': true, 'tabActive': tabMenuFlag}">
                    <li @click="checkTab(0)" :class="{active: tabIndex === 0}">最新<span :class="{line: tabIndex === 0}"></span></li>
                    <li @click="checkTab(1)" :class="{active: tabIndex === 1}">最热<span :class="{line: tabIndex === 1}"></span></li>
                    <li @click="checkTab(2)" :class="{active: tabIndex === 2}">投票<span :class="{line: tabIndex === 2}"></span></li>
                    <li></li>
                </ul>
                <!-- 最新 -->
                <div class="newList" v-show="tabIndex === 0">
                    <waterfall 
                        :col='col' 
                        :data="newList"
                        :width="itemWidth" 
                        :gutterWidth="gutterWidth"
                        @loadmore="loadmore"  
                    >
                        <template>
                            <div v-for="item in newList" :key="item.id">
                                <WaterfallList :type="2" :isPattingAll="true" :data="item" />
                            </div>
                        </template>
                    </waterfall>
                    <div class="no-more" v-show="!newEmpty">加载中...</div>
                    <div class="no-more" v-show="newEmpty">没有更多了</div>
                </div>
                <!-- 最热 -->
                <div class="hotList" v-show="tabIndex === 1">
                    <waterfall 
                        :col='col' 
                        :data="hotList"
                        :width="itemWidth" 
                        :gutterWidth="gutterWidth"
                        @loadmore="loadmore"   
                    >
                        <template>
                            <div v-for="item in hotList" :key="item.id">
                                <WaterfallList :type="2" :isPattingAll="true" :data="item" />
                            </div>
                        </template>
                    </waterfall>
                    <div class="no-more" v-show="!hotEmpty">加载中...</div>
                    <div class="no-more" v-show="hotEmpty">没有更多了</div>
                </div>
                <!-- 投票 -->
                <div class="voteList" v-show="tabIndex === 2">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="initTopicDetails2"
                    >
                        <van-cell
                            v-for="(item, index) in rankList"
                            :key="item.id"
                        >
                            <div @click="jumpRankDet(item.share)" class="vote-item">
                                <div class="cover-img">
                                    <img :src="item.cover ? item.cover : ''" alt="">
                                    <i :class="{'rank': true, 'rank_1': index+1 === 1, 'rank_2': index+1 === 2, 'rank_3': index+1 === 3, 'rank_9': index+1>3&&index+1<10, 'rank_99': index+1>=10 }">TOP.{{index + 1}}</i>
                                </div>
                                <div class="vote-info">
                                    <p>{{ item.content ? item.content : "" }}</p>
                                    <div>
                                        <div class="s_user">
                                            <div>
                                                <img :src="item.user.image" alt="">
                                                <i :class="[item.user.gender ? item.user.gender == 'm' ? 'man' : 'women' : '']"></i>
                                            </div>
                                            <span>{{item.user.nickname}}</span>
                                        </div>
                                        <div class="dianzan">
                                            <span>{{item.comment_num}}</span>
                                            <span>{{item.like}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-cell>
                    </van-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Header, WaterfallList } from "@/components";
import { myListener, cutString } from "../../../../../util";
import { getPattingTopicDet, getPattingTopicDet2 } from "@/request/api";
import { checkWx, navigate } from '@/pages/index/custom'

export default {
    components: {
        Header,
        WaterfallList
    },
    data() {
        return {
            isShow: false, // 收起展开
            tabIndex: 0, // 选项卡索引
            col: 2, // 瀑布流列数
            newList: [], // 最新列表
            newPage: 1,
            hotList: [], // 最热列表
            hotPage: 1,
            rankList: [], // 排行列表
            rankPage: 1,
            newEmpty: false, // 加载完毕
            hotEmpty: false, // 加载完毕
            loading: false,  // 加载中
            finished: false,  // 加载完毕
            topicDetails: null, //话题详情
            headFlag: false,
            tabMenuFlag: false,
            isWx: true
        };
    },
    methods: {
        // 排行详情
        jumpRankDet(url) {
            navigate('', url)
        },
        goBack() {
            this.$router.go(-1);
        },
        // 展开收起
        showToggle() {
            let { showIcon, intro } = this.$refs;
            this.isShow = !this.isShow;
            if(this.isShow) {
                showIcon.style.transform = 'rotate(180deg)';
            } else {
                showIcon.style.transform = 'rotate(0deg)';
            }
            let height= this.$refs.intro.offsetHeight;
            // console.log(height)
        },
        // 选项卡切换
        checkTab(index) {
            this.tabIndex = index;
            if(index === 0) {
                if(this.newList.length <= 0) this.initTopicDetails2();
            } else if(index === 1) {
                if(this.hotList.length <= 0) this.initTopicDetails2();
            } else if(index === 2) {
                if(this.rankList.length <= 0) this.initTopicDetails2();
            }
        },
        // 瀑布流
        loadmore(){
            if(this.tabIndex != 2) this.initTopicDetails2();
        },
        // 获取话题详情
        initTopicDetails() {
            let {id} = this.$route.query;
            getPattingTopicDet({
                id: id
            }).then(res => {
                let {error_code, data} = res;
                if(error_code == 0) {
                    this.topicDetails = data.tag;
                }
            }).catch(err => {
                console.log(err);
            })
        },
        // 获取话题详情2
        initTopicDetails2() {
            let index = this.tabIndex;
            let { id } = this.$route.query;
            let type, page;
            switch (index) {
                case 0: type = 1; page = this.newPage;
                    break;
                case 1: type = 2; page = this.hotPage;
                    break;
                case 2: type = 3; page = this.rankPage;
                    break;
                default: type = 1; page = this.newPage;
                    break;
            }
            getPattingTopicDet2({
                id: id,
                opt: type,
                page: page,
                pcount: 10,
            }).then(res => {
                let {video, error_code} = res;
                if(error_code === 0) {
                    if(index === 0) {
                        if(video.length > 0) {
                            this.newList = this.newList.concat(video);
                            this.newPage++;
                        } else {
                            this.newEmpty = true
                        }
                    } else if(index === 1) {
                        if(video.length > 0) {
                            this.hotList = this.hotList.concat(video);
                            this.hotPage++;
                        } else {
                            this.hotEmpty = true
                        }
                    } else if(index === 2) {
                        if(video.length === 0 || !video) {
                            this.finished = true;
                            return false
                        }
                        video.map( item => this.rankList.push(item) )
                        this.rankPage++;
                        this.loading = false;
                    }
                }
            }).catch(err => {
                console.log(err);
            })
        },
    },
    computed:{
        itemWidth(){  
            return Math.floor((document.documentElement.clientWidth-55)/2)
        },
        gutterWidth(){
            return 15
        }
    },
    created() {
        this.isWx = checkWx();
        let that = this;
        this.listen = myListener(
            window,
            "scroll",
            e => {
                var scrollTop =
                    e.target.documentElement.scrollTop ||
                    e.target.body.scrollTop;
                    if(!that.isWx) {
                        if(scrollTop > 80) {
                            this.headFlag = true
                        } else {
                            this.headFlag = false
                        }
                    }
                    if(scrollTop > 280) {
                        this.tabMenuFlag = true
                    } else {
                        this.tabMenuFlag = false
                    }
            },
            true
        );
        this.initTopicDetails();
        this.initTopicDetails2();
    },
    beforeCreate: function () {
        document.getElementsByTagName('html')[0].style.height = 'auto'
        document.getElementsByTagName('body')[0].style.height = 'auto'
    },
    destroyed() {
        this.listen();
    }
};
</script>

<style lang="less" scoped>
.no-more {
    text-align: center;
    height: 1.875rem;
    color: #ccc;
    font-size: 14px;
}
.tabActive {
    position: fixed;
    left: 0;
    background: #fff;
    z-index: 10000;
    padding-left: 20px;
    padding-right: 20px
}
.tabActive2 {
    position: fixed;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 10000;
    padding-left: 20px;
    padding-right: 20px
}
.tophead {
    height: 3.75rem;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
    background-color: transparent;
    transition: all .3s;
    i {
        position: absolute;
        left: 1.25rem;
        top: 50%;
        margin-top: -8px;
        width: 24px;
        height: 24px;
    }
    .back_1 {
        background: url(../../../../assets/img/icon_back_w.png) no-repeat;
        background-size: 100% 100%;
    }
    .back_2 {
        background: url(../../../../assets/img/icon_back.png) no-repeat;
        background-size: 100% 100%;
    }
    span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size:18px;
        font-weight:500;
        color:rgba(34,34,34,1);
    }
}
.topicDetails {
    .content {
        background-color: #fff;
        .bg {
            height: 18.75rem;
            width: 100%;
            position: relative;
            &::after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 99;
                background:linear-gradient(360deg,rgba(255,255,255,1) 0%,rgba(255,255,255,0) 16%,rgba(255,255,255,0) 100%);
            }

        }
    }
}
.vote-item {
    height: 10rem;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 1px solid #eee;
    padding: 1.25rem 0;
    display: flex;
}
.cover-img {
    width: 7.5rem;
    height: 7.5rem;
    border-radius: .375rem;
    overflow: hidden;
    position: relative;
}
.vote-info {
    -prefix-box-flex: 1;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    margin-left: .75rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.cover-img img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
}
.rank {
    position: absolute;
    top: 0;
    left: 0;
    width: 4.125rem;
    height: 1.5rem;
    background: url(../../../../assets/img/vote_4.png) no-repeat center center;
    background-size: 100% 100%;
    font-size: 12px;
    font-weight: 500;
    color: #fff;
    line-height: 1.5rem;
    text-align: right;
    padding-right: .25rem;
    box-sizing: border-box;
}
.vote-info p {
    font-size: 18px;
    font-weight: 500;
    color: rgba(34,34,34,1);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
}
.vote-info > div {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.vote-info .s_user {
    position: relative;
    left: 0;
    bottom: 0;
}
.s_user {
    position: absolute;
    height: 2.25rem;
    bottom: .375rem;
    left: .75rem;
    display: flex;
    align-items: center;
}
.dianzan {
    margin: 0;
    display: flex;
    align-items: center;
    margin-top: .75rem;
}
.vote-info .s_user > span {
    color: #222;
}
.s_user span {
    font-size: 12px;
    font-weight: 400;
    color: #fff;
    margin-left: 4px;
}
.s_user div {
    position: relative;
}
.s_user img {
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    overflow: hidden;
    border: 1px solid rgba(238,238,238,1) !important;
}
.s_user div i {
    position: absolute;
    width: .625rem;
    height: .625rem;
    right: 0;
    bottom: 0;
    
}
.man {
    background: url(../../../../assets/img/icon_man.png) no-repeat center center;
    background-size: 100% 100%;
}
.women {
    background: url(../../../../assets/img/icon_women.png) no-repeat center center;
    background-size: 100% 100%;
}
.dianzan span {
    padding-left: 1.375rem;
    font-size: 12px;
    font-weight: 400;
    color: rgba(34,34,34,1);
}
.dianzan span:nth-child(1) {
    background: url(../../../../assets/img/line@2x.png) no-repeat center left;
    background-size: 1.25rem 1.25rem;
}
.dianzan span:nth-child(2) {
    background: url(../../../../assets/img/toolbar.png) no-repeat center left;
    background-size: 1.25rem 1.25rem;
    margin-left: 1.375rem;
}
.rank_1 {
    background: url(../../../../assets/img/vote_1.png) no-repeat center center;
    background-size: 100% 100%;
}
.rank_2 {
    background: url(../../../../assets/img/vote_2.png) no-repeat center center;
    background-size: 100% 100%;
}
.rank_3 {
    background: url(../../../../assets/img/vote_3.png) no-repeat center center;
    background-size: 100% 100%;
}
.rank_9 {
    width: 73px;
    background: url(../../../../assets/img/vote_5.png) no-repeat center center;
    background-size: 100% 100%;
}
.rank_99 {
    width: 87px;
    background: url(../../../../assets/img/vote_6.png) no-repeat center center;
    background-size: 100% 100%;
}
.listBox {
    box-sizing: border-box;
    margin-top: 1.5rem;
    padding: 0 1.25rem;
    // background-color: #fff;
    width: 100%;
    position: relative;
    top: -9.0625rem;
    left: 0;
    z-index: 500;
    .list {
        width: 100%;
        height: auto;
    }
    .intro {
        width: 20.9375rem;
        height: auto;
        border-radius: .25rem;
        background-color: rgba(255, 255, 255, .8);
        padding: 1.25rem;
        box-sizing: border-box;
        margin: 0 auto;
        overflow: hidden;
        transition: all .3s;
        position: relative;
        .title {
            font-size:22px;
            font-weight:500;
            color:rgba(34,34,34,1);
        }
        p {
            margin-top: 7px;
            font-size:14px;
            font-weight:400;
            color:rgba(34,34,34,1);
            line-height:22px;
        }
        .open {
            position: absolute;
            bottom: 0;
            right: 40px;
            span {
                font-size:14px;
                font-weight:400;
                color:rgba(46,140,255,1);
            }
            i {
                width: 1rem;
                height: 1rem;
                background: url(../../../../assets/img/icon_zhankai.png) no-repeat;
                background-size: 100% 100%;
                transition: all .3s;
            }
        }
    }
}
.tab {
    height: 3.75rem;
    width: 100%;
    box-sizing: border-box;
    transition: all .3s;
}
.tab::after {
    content: "";
    display: block;
    clear: both;
}
.tab li {
    float: left;
    margin-right: 1.5rem;
    font-size:16px;
    font-weight:400;
    color:rgba(34,34,34,1);
    position: relative;
    height: 100%;
    line-height: 3.75rem;
    transition: all .3s;
}
.tab li.active {
    font-size:24px;
    font-weight:600;
}
.tab li:last-child {
    float: right; 
    font-size: 12px; 
    font-weight: 400; 
    color: #646464;
    margin: 0;
}
.tab .line {
    position: absolute;
    bottom: 8px;
    left: 50%;
    margin-left: -0.625rem;
    width: 1.25rem;
    height: .25rem;
    background-color: #FF4C67;
    box-shadow: 0px 2px 6px 0px #fd7c90;
    border-radius: 10px;
}
.newList, .hotList, .rankList {
    margin-top: 1.25rem;
}
</style>
